import * as Sentry from '@sentry/react'

import { SENTRY_DSN, isProduction } from '@/utils/constants.ts'

import { isDebugSentry, isSentryEnabled } from './consts'
import { handleBeforeBreadcrumb } from './utils'

if (isProduction) {
  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: isSentryEnabled,
    release: window.__APP_VERSION__,
    debug: isDebugSentry,
    environment: import.meta.env.MODE,
    beforeBreadcrumb: handleBeforeBreadcrumb,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['CancelError', 'CanceledError', 'AxiosError', 'ApiError'],
  })

  import('@sentry/browser').then((lazyLoadedSentry) => {
    Sentry.addIntegration(
      lazyLoadedSentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    )
  })
}

export const setUserContext = (userId: number) => {
  Sentry.setUser({
    id: userId,
  })
}
